import { Grid } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import SimpleCard from '../../utils/card';
import { ROL_USER } from '../../app/api-client/constants';
import { SiGooglemaps } from "react-icons/si";

export const Home = (props) => {
    const rol = localStorage.getItem(ROL_USER);
    const history = useHistory();

    const handleBasculas = () => {
        history.push(`/basculas/`);
    }

    const handleEncuestas = () => {
        history.push(`/Pollpanel`);
    }


    const handledAdministracion = () => {
        history.push(`/Administracion`);
    }

    const handleUbicacion = () => {
        history.push(`/Ubicaciones`);
    }
    const handleDatos = () => {
        history.push(`/Datos`);
    }
    const handleRegistrosDeUsos = () => {
        history.push(`/RegistrosDeUso`);
    }

    return (
        <Grid container spacing={1} style={{ marginBottom: '35%', marginTop: '2%', marginLeft: 0, marginRight: 0 }}>

            <Grid item xs={12} sm={6}>
                <SimpleCard
                    title="Estaciones"
                    messageInfo="Administración de estaciones de tele salud"
                    img="bascula"
                    event={handleBasculas}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SimpleCard
                    title="Registro de Uso"
                    messageInfo="Registro de Uso"
                    img="datos"
                    event={handleRegistrosDeUsos}
                />
            </Grid>

            {(rol === "ROLE_ADMIN" || rol === "ROLE_CLIENT") && (
                <Grid item xs={12} sm={6}>
                    <SimpleCard
                        title="Encuestas"
                        messageInfo="Modulo de administración de encuestas"
                        img="encuestas"
                        event={handleEncuestas}
                    />
                </Grid>
            )}

            {rol === "ROLE_ADMIN" && (
                <Grid item xs={12} sm={6}>
                    <SimpleCard
                        title="Administracion"
                        messageInfo="Administracion"
                        img="administracion"
                        event={handledAdministracion}
                    />
                </Grid>
            )}

            {rol === "ROLE_ADMIN" && (
                <Grid item xs={12} sm={6}>
                    <SimpleCard
                        title="Ubicaciones"
                        messageInfo="Ubicaciones"
                        img="mapa"
                        event={handleUbicacion}
                    />
                </Grid>
            )}
            {rol === "ROLE_ADMIN" && (
                <Grid item xs={12} sm={6}>
                    <SimpleCard
                        title="Datos"
                        messageInfo="Registro de mediciones"
                        img="datos"
                        event={handleDatos}
                    />
                </Grid>
            )}
        </Grid>
    );
}
